module.exports = __webpack_public_path__ + "res/ic_checked.4cf290a110f76db46268319ee96858bf.png";